import React from 'react';
import {createPortal} from 'react-dom';

/**
 * Props for the internal tooltip used by SymbolPicker's TruncatedText cells.
 */
export type TooltipProps = {
  text: string;
  targetRect: DOMRect;
  width?: number;
};

/**
 * Fixed-position tooltip rendered into document.body via a portal. The tooltip
 * clamps itself to the viewport so it stays visible even when the target cell
 * sits near the right edge of the screen.
 */
export const Tooltip: React.FC<TooltipProps> = ({text, targetRect, width = 180}) => {
  const padding = 12;
  const spacing = 8;

  let left = targetRect.left + (targetRect.width / 2) - (width / 2);
  const top = targetRect.bottom + spacing;

  const viewportWidth = window.innerWidth;
  if (left < padding) {
    left = padding;
  }

  if (left + width > viewportWidth - padding) {
    left = viewportWidth - width - padding;
  }

  const arrowLeft = targetRect.left + (targetRect.width / 2) - left;

  return createPortal(
    <div
      className='sp-tooltip'
      style={{top, left, width}}
    >
      <div className='sp-tooltip-inner'>
        {text}
        <div
          className='sp-tooltip-arrow'
          style={{left: `${arrowLeft}px`}}
        />
      </div>
    </div>,
    document.body,
  );
};
